module.exports = (__webpack_require__(0))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/View.js from dll-reference girder_lib
// module id = 2
// module chunks = 0